import axios from '@/axios/axios2'

// 获取伙伴业绩日维度
export const gethuobanyjday = params =>
  axios.post('/app/gethuobanyjday', params)

// 获取伙伴业绩月维度
export const gethuobanyjmonth = params =>
  axios.post('/app/gethuobanyjmonth', params)

//-----------------------------改版后↓---------------------------------------
// 获取伙伴业绩日维度
export const getDataPartnerDay = params =>
  axios.post('/statistics/getDataPartnerDay', params)

// 获取伙伴业绩月维度
export const getDataPartnerMonth = params =>
  axios.post('/statistics/getDataPartnerMonth', params)
